export const SERVICES = {
  MY_FPO: "myFPO",
  MY_BUSINESS: "myBusiness",
};
